import qs from 'qs'

export const queryExhibitionEntryExtremeDateRange = (locale: QueryLocaleString, sort: any) => {
  const query = qs.stringify(
    {
      locale: locale || 'en-US',
      sort: sort || ['dateStart:asc', 'dateEnd:asc'],
      pagination: {
        limit: 1
      },
      fields: [
        'dateStart',
        'dateEnd'
      ]
    },
    {
      encodeValuesOnly: true
    }
  )
  return `exhibition-entries?${query}`
}
